import React, { memo, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { FiHeart } from "react-icons/fi";
import { FaHeart } from "react-icons/fa";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { TbDoor, TbPhotoVideo, TbUsers } from "react-icons/tb";
import { MdPlayCircle } from "react-icons/md";
import ImgSkeleton from "../../../../Assets/pngs/img_skeleton.png";
// import { usePropertyVideos } from "../../../../hooks/property/usePropertyVideos";

const PropertyCard = memo(({ property, baseRoute, isSaved, handleFavoriteClick }) => {
  // const { videos, fetchVideos } = usePropertyVideos(property.id);

  // useEffect(() => {
  //   if (!property.cover_image) fetchVideos();
  // }, [property.id, property.cover_image]);

  // const firstVideo = videos[0] || null;
  // Correctly picks the first video object from the array
  const firstVideo = property?.videos_data?.[0] || null;

  const playPromiseRef = useRef(null);

  const handleMouseEnter = (e) => {
    const videoElem = e.currentTarget;
    // Store the returned Promise
    playPromiseRef.current = videoElem.play();
  };

  const handleMouseLeave = (e) => {
    const videoElem = e.currentTarget;

    if (playPromiseRef.current !== null) {
      // Wait for play() to resolve before pausing
      playPromiseRef.current
        .then(() => {
          videoElem.pause();
          videoElem.currentTime = 0;
        })
        .catch((err) => {
          if (err.name !== "AbortError") {
            console.error("Video pause error:", err);
          }
        });
    } else {
      videoElem.pause();
      videoElem.currentTime = 0;
    }
  };

  return (
    <Link to={`${baseRoute}accommodation-details/${property.id}`} className="flex flex-col h-full">
      <div className="relative bg-white rounded-3xl shadow-lg overflow-hidden hover:shadow-xl transition flex flex-col h-full">
        <div className="relative">

          {property.cover_image ? (
            <img
              src={property.cover_image}
              alt={property.title}
              onError={(e) => { e.target.onerror = null; e.target.src = ImgSkeleton; }}
              className="w-full h-72 md:h-96 object-cover"
            />
          ) : firstVideo ? (
            <div className="relative w-full h-72 md:h-96 bg-black">
              <video
                src={firstVideo.video}
                className="w-full h-full object-cover opacity-80"
                muted
                playsInline
                preload="metadata"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              />
              <TbPhotoVideo
                className="absolute bottom-24 right-2 m-auto text-white pointer-events-none"
                size={30}
              />
            </div>
          ) : (
            <div className="w-full h-72 md:h-96 bg-gray-100 flex items-center justify-center">
              <MdPlayCircle size={40} className="text-gray-300" />
            </div>
          )}

          {/* Price + Favorite — unchanged */}
          <div className="absolute top-0 left-0 w-full p-3 flex items-start justify-between pointer-events-none">
            <p className="text-xs md:text-base font-semibold text-white drop-shadow-md bg-black/30 px-3 py-2 rounded-full backdrop-blur-[2px]">
              €{property.rent_per_month}
            </p>
            {/* <button
              onClick={(e) => handleFavoriteClick(e, property)}
              className="pointer-events-auto p-2 rounded-full bg-white/90 backdrop-blur-sm shadow-lg hover:scale-110 active:scale-95 transition-all z-10"
              aria-label="Toggle Favorite"
             >
              {isSaved ? (
                <FaHeart className="text-red-500 animate-pulse" size={18} />
              ) : (
                <FiHeart className="text-gray-600 hover:text-red-500 transition-colors" size={18} />
              )}
            </button> */}
          </div>
        </div>

        {/* Info overlay — unchanged */}
        <div className="absolute bg-black/20 backdrop-blur-sm bottom-0 left-0 right-0 p-3 flex flex-col flex-1 text-white rounded-b-2xl">
          <h2 className="text-base md:text-lg font-semibold line-clamp-1">{property.title}</h2>
          <p className="text-white/90 text-xs flex items-center gap-1">
            <HiOutlineLocationMarker /> {property.city}, {property.country}
          </p>
          <p className="text-[10px] md:text-sm text-white/90 flex items-center gap-1 md:gap-3 mt-1">
            <TbDoor /> {property.rooms} Rooms <TbUsers /> Max {property.max_people} people
          </p>
        </div>
      </div>
    </Link>
  );
});

export default PropertyCard;